import { IEntityCreateFailure, RequestAction, createRequestTypes } from "store/entities/actions";
import { ActionsUnion, IAction, IActionWithPayload, createAction } from "store/helper";

import {
  IAgentBatchCreatePayload,
  IAgentDeletePayload,
  IAgentUpdatePayload,
  IFetchLiveChatAgentsSuccessPayload,
  IImportLiveChatAgentFailurePayload,
  IImportLiveChatAgentPayload,
  ISetSelectedAgentPayload,
  ISort,
} from "./interfaces";

export const AgentsViewActionsNames = {
  BATCH_CREATE_AGENTS: "VIEWS/AGENTS/BATCH_CREATE_AGENTS",
  UPDATE_AGENT: "VIEWS/AGENTS/UDPATE_AGENT",
  DELETE_AGENT: "VIEWS/AGENTS/DELETE_AGENT",
  SET_SELECTED_AGENT: "VIEWS/AGENTS/SET_SELECTED_AGENT",
  SET_FOCUSED_COLUMN: "VIEWS/AGENTS/SET_FOCUSED_COLUMN",
  SET_LIST_SORTING: "VIEWS/AGENTS/SET_LIST_SORTING",
  FETCH_LIVECHAT_AGENTS: "VIEWS/AGENTS/FETCH_LIVECHAT_AGENTS",
  FETCH_LIVECHAT_AGENTS_SUCCESS: "VIEWS/AGENTS/FETCH_LIVECHAT_AGENTS_SUCCESS",
  IMPORT_LIVECHAT_AGENT: createRequestTypes("VIEWS/AGENTS/IMPORT_LIVECHAT_AGENT"),
};

const importLiveChatAgentActions = {
  importLiveChatAgent: (
    payload: IImportLiveChatAgentPayload
  ): IActionWithPayload<string, IImportLiveChatAgentPayload> =>
    createAction(AgentsViewActionsNames.IMPORT_LIVECHAT_AGENT[RequestAction.REQUEST], payload),
  importLiveChatAgentSuccess: (): IAction<string> =>
    createAction(AgentsViewActionsNames.IMPORT_LIVECHAT_AGENT[RequestAction.SUCCESS]),
  importLiveChatAgentFailure: (
    payload: IImportLiveChatAgentFailurePayload
  ): IActionWithPayload<string, IEntityCreateFailure> =>
    createAction(AgentsViewActionsNames.IMPORT_LIVECHAT_AGENT[RequestAction.FAILURE], payload),
};

export const AgentsViewActions = {
  ...importLiveChatAgentActions,
  createAgentsBatchRequest: (payload: IAgentBatchCreatePayload): IActionWithPayload<string, IAgentBatchCreatePayload> =>
    createAction(AgentsViewActionsNames.BATCH_CREATE_AGENTS, payload),
  updateAgent: (payload: IAgentUpdatePayload): IActionWithPayload<string, IAgentUpdatePayload> =>
    createAction(AgentsViewActionsNames.UPDATE_AGENT, payload),
  deleteAgent: (payload: IAgentDeletePayload): IActionWithPayload<string, IAgentDeletePayload> =>
    createAction(AgentsViewActionsNames.DELETE_AGENT, payload),
  setSelectedAgent: (payload: ISetSelectedAgentPayload): IActionWithPayload<string, ISetSelectedAgentPayload> =>
    createAction(AgentsViewActionsNames.SET_SELECTED_AGENT, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setFocusedColumn: (focusedColumn: number) =>
    createAction(AgentsViewActionsNames.SET_FOCUSED_COLUMN, { focusedColumn }),
  setListSorting: (payload: ISort): IActionWithPayload<string, ISort> =>
    createAction(AgentsViewActionsNames.SET_LIST_SORTING, payload),
  fetchLiveChatAgents: (): IAction<string> => createAction(AgentsViewActionsNames.FETCH_LIVECHAT_AGENTS),
  fetchLiveChatAgentsSuccess: (
    payload: IFetchLiveChatAgentsSuccessPayload
  ): IActionWithPayload<string, IFetchLiveChatAgentsSuccessPayload> =>
    createAction(AgentsViewActionsNames.FETCH_LIVECHAT_AGENTS_SUCCESS, payload),
};

export type AgentsViewAction = ActionsUnion<typeof AgentsViewActions>;
